const PdfDocumentTypeEnum = Object.freeze({
    FORM_1099: "1099_analysis|1099 Analysis",
    Bank_Statement: "ledger|Ledger",
    Auditor_Assistant: "auditor_assistant|Auditor Assistant",
    Code_Of_Account_Agent: "coa_agent|Code of Account Agent"
});

const ProcessFileStatus = Object.freeze({
    COMPLETED: "completed",
    PROCESSING: "processing",
});
  
export { PdfDocumentTypeEnum, ProcessFileStatus };